import * as React from 'react'
import _ from 'lodash'
import { SelectInput, TextInput, DateInput } from 'react-admin'
import { inlineInputStyle } from '../../../hooks/CustomListFilter'

export const CouponsListFiltersArray: {
  value: string
  label: string
  FilterInput: JSX.Element
}[] = _.sortBy(
  [
    {
      value: 'code',
      label: 'Código',
      FilterInput: (
        <TextInput
          source="code"
          label="Código"
          style={inlineInputStyle}
          variant={'outlined'}
          size={'small'}
          key={'code'}
        />
      ),
    },
    {
      value: 'status',
      label: 'Status',
      FilterInput: (
        <SelectInput
          source="status"
          label="Status"
          choices={[
            { id: 'active', name: 'Ativo' },
            { id: 'inactive', name: 'Inativo' },
            { id: 'expired', name: 'Expirado' },
            { id: 'archived', name: 'Arquivado' },
          ]}
          style={inlineInputStyle}
          variant={'outlined'}
          size={'small'}
          key={'status'}
        />
      ),
    },
    {
      value: 'type',
      label: 'Tipo',
      FilterInput: (
        <SelectInput
          source="type"
          label="Tipo"
          choices={[
            { id: 'percentage', name: 'Porcentagem' },
            { id: 'fixed', name: 'Valor fixo' },
            { id: 'fixedPrice', name: 'Preço fixo' },
          ]}
          style={inlineInputStyle}
          variant={'outlined'}
          size={'small'}
          key={'type'}
        />
      ),
    },
    {
      value: 'appliesTo',
      label: 'Aplica-se a',
      FilterInput: (
        <SelectInput
          source="appliesTo"
          label="Aplica-se a"
          choices={[
            { id: 'all_products', name: 'Todos os produtos' },
            { id: 'categories', name: 'Categorias' },
            { id: 'specific_products', name: 'Produtos específicos' },
          ]}
          style={inlineInputStyle}
          variant={'outlined'}
          size={'small'}
          key={'appliesTo'}
        />
      ),
    },
    {
      value: 'validFrom',
      label: 'Válido de',
      FilterInput: (
        <DateInput
          source="validFrom"
          label="Válido de"
          style={inlineInputStyle}
          variant={'outlined'}
          size={'small'}
          key={'validFrom'}
        />
      ),
    },
    {
      value: 'validUntil',
      label: 'Válido até',
      FilterInput: (
        <DateInput
          source="validUntil"
          label="Válido até"
          style={inlineInputStyle}
          variant={'outlined'}
          size={'small'}
          key={'validUntil'}
        />
      ),
    },
  ],
  'label'
)

export default CouponsListFiltersArray
